export const frLocaleFrontOffice = {
    locale: 'fr',
    messages: {
        // API ERRORS
        'toast.error.FORMATION_CONNECTION_ALREADY_EXIST': 'Cette formation a deja été ajoutée',

        // HOME MAIN BAR
        'pst.main.bar.title': 'ACCUEIL MON ESPACE',
        'pst.main.bar.disconnection': 'DECONNEXION',
        'pst.main.bar.disconnection.dialog.title': 'Souhaitez-vous vous déconnecter ? ',
        'pst.main.bar.disconnection.dialog.description':
            'Les sessions de formations et les données de votre profils seront effacées.',
        'pst.main.bar.disconnection.toast.succes': 'Déconnecté !',

        // PROFIL
        'profile.content.label.lastname': 'Nom',
        'profile.content.label.firstname': 'Prenom',
        'profile.content.label.date': 'Date de naissance',
        'profile.content.input.placeholder.lastname': 'Nom',
        'profile.content.input.placeholder.firstname': 'Prenom',
        'profile.content.input.placeholder.date': 'MM/DD/AAAA',
        'profile.content.label.save': 'Enregistrer',

        // HOME PAGE
        'home.page.formation.list.title': 'Mes Formations',
        'home.page.profile.title': 'Mon Profil',
        'home.page.news.title': 'Actualités',
        'home.page.cgu': 'Accéder aux CGU',

        // FORMATION

        // FORMATION LIST
        'home.page.formation.list.add.formation.label': 'Ajouter une formation',
        'home.formation.list.label.date.future': 'À venir - {future}',
        'home.formation.list.label.date.past': 'Passée - {past}',

        // FORMATION ADD

        // FORMATION ADD > EXIT DIALOG
        'home.page.formation.add.quit.modal.title': 'Voulez-vous vraiment quitter ?',
        'home.page.formation.add.quit.modal.description': 'Toutes vos renseignements de session seront perdues.',

        // FORMATION ADD > FORMATION DIALOG
        'home.page.formation.add.title': 'Ajout d’une formation',
        'home.page.formation.add.message':
            'Pour ajouter une nouvelle formation à votre liste, indiquez le numéro de formation correspondant.',
        'formation.add.dialog.input.formation': 'ex. H54KLP-N2',
        'formation.add.dialog.input.pin': '* * * *',

        'formation.add.dialog.checkbox.did_accept_cgu': "J'accepte les conditions générales d'utilisation",
        'formation.add.dialog.checkbox.did_accept_cgu.link': 'Consulter',

        'formation.add.dialog.formation.name.error.message': 'Identifiant de la formation incorrect',
        'formation.add.dialog.formation.pin.code.error.message': 'Code PIN de la formation incorrect',

        'home.page.formation.add.button': 'Valider',

        // FORMATION ADD > PROFILE DIALOG
        'home.page.formation.add.profil.title': 'Profil à compléter',
        'home.page.formation.add.profil.message':
            'Les informations de votre profil sont obligatoires pour pouvoir continuer, merci de bien vouloir les remplir.',

        // FORMATION ADD > FORMATION ADD SUCCES DIALOG
        'home.page.formation.add.success.dialog.title': 'Nouvelle formation ajoutée !',
        'home.page.formation.add.success.dialog.message':
            'Bienvenue dans votre espace formation {title} ! Vous y trouverez toutes les informations nécessaires au bon déroulement de votre stage, bibliothèque de documents, tests, vidéos, ainsi qu’un questionnaire de satisfaction à compléter dès la fin de votre formation.',
        'home.page.formation.go.formation.details.button': 'Accès formation',

        // FORMATION DETAILS
        'formation.details.list.content.refresh': 'Actualiser le contenu',
        'formation.details.list.content.pdf': 'Bibliothèque',
        'formation.details.list.content.rules': 'Repères règlementaires',
        'formation.details.list.content.quiz': 'Quiz',
        'formation.details.list.content.video': 'Vidéos',
        'formation.details.list.content.satisfaction': 'Enquête satisfaction',

        'formation.details.unsubscribe.button.label': 'Se désinscrire de la session de formation',
        'formation.details.unsubscribe.dialog.title': 'Se désinscrire de la session de formation',
        'formation.details.unsubscribe.dialog.message':
            'Souhaitez vous vraiment vous désinscrire de la session de formation ?',

        'formation.details.content.date.label': 'Date(s) : ',
        'formation.details.content.duration.label': 'Durée : {duration} ',
        'formation.details.content.session.type.label': 'Type de session : {session_type} ',
        'formation.details.content.instructor.name.label': 'Formateur : {first_name} {last_name} ',
        'formation.details.content.instructor.email.label': 'Mail formateur : {email} ',
        'formation.details.content.end.date.label': 'Contenu disponible jusqu’au {date} ',
        'formation.details.content.goal.label': 'Objectifs',

        'formation.details.button.back.label': 'Retour au detail de la formation',

        // FORMATION DETAILS > DETAILS RULES
        'formation.details.rules.title': 'Repères règlementaires',

        // FORMATION DETAILS > DETAILS PDFS
        'formation.details.pdfs.title': 'Bibliothèque',
        'formation.details.pdfs.header.title': 'Titre',
        'formation.details.pdfs.header.download': 'Téléchargement',

        // FORMATION DETAILS > DETAILS PDFS
        'formation.details.videos.title': 'Vidéos',
        'formation.details.videos.infos.duration': 'Durée',

        // FORMATION DETAILS > DETAILS QUIZZES

        // > DETAILS QUIZZES > QUIZZES LIST
        'formation.details.quizzes.title': 'Quiz',

        'formation.details.available.quizzes.list.title': 'Disponible(s)',
        'formation.details.answered.quizzes.list.title': 'Répondu(s)',
        'formation.details.responds.available.quizzes.list.title': 'Réponse(s) disponible(s)',

        'quiz.single.question.button.validation.label': 'Répondre et passer à la question suivante',

        // > DETAILS QUIZZES > SINGLE QUIZ
        'quiz.details.page.button.validation': 'Valider',

        'quiz.details.page.answer.display.message.1': 'Toutes les réponses en orange sont VOS réponses.',
        'quiz.details.page.answer.display.message.2':
            'Toutes les réponses en vert sont les bonnes réponses communiquées par le formateur.',

        'quiz.missing.answers.errors.message':
            'Vous ne pouvez pas valider, vous n’avez pas répondu aux questions : {question_list}. Merci d’y répondre avant de valider.',
        'quiz.confirm.save.dialog.message': 'Valider les réponses ?',
        'quiz.confirm.dialog.button.confirm': 'Confirmer',
        'quiz.confirm.dialog.button.cancel': 'Annuler',

        'quiz.validate.dialog.confirm.title': 'Quiz terminé !',
        'quiz.validate.dialog.confirm.message':
            'Bravo, vous avez terminé le quiz {quiz} de votre formation {formation} ! Votre formateur vous indiquera lorsque les réponses seront consultables.',

        'quiz.exit.confirm.dialog.message':
            'Souhaitez-vous vraiment quitter ce quiz ? Toutes les réponses répondues ne seront pas sauvegardées',

        // FORMATION DETAILS > DETAILS QUIZZES > SINGLE QUIZ BOX
        'single.quiz.box.questions.count.message': '{number} question(s)',
        'quiz.single.question.type.text.label': 'TEXTE - ',
        'quiz.single.question.type.single.response.label': 'Choix unique - ',
        'quiz.single.question.type.multiple.response.label': 'Choix multiple - ',
        'quiz.single.question.type.text.replay.quiz': 'REFAIRE LE QUIZ',

        // FORMATION DETAILS > DETAILS SATISFACTION SURVEY
        'satisfaction.survey.page.title': 'Enquête satisfaction',

        'satisfaction.survey.page.exit.confirm.dialog.message':
            'Souhaitez-vous vraiment quitter le questionnaire de satisfaction ? Toutes les réponses répondues ne seront pas sauvegardées',

        'satisfaction.survey.validate.dialog.confirm.title': 'Questionnaire de satisfaction terminé !',
        'satisfaction.survey.validate.dialog.confirm.message':
            'Merci d’avoir répondu au questionnaire de satisfaction de votre formation !',

        // NEWS DETAILS

        'news.details.page.back.button.label': 'Retour accueil',
        'news.details.page.actu.list.title': 'Dernières actualités',
    },
};
